
<script setup lang="ts">
import { onBeforeMount, provide } from 'vue';
import { getHostRouter } from '@Src/mfe.config';
import { getCompanySlug } from 'host/mfeBridge';
import { useRequestFlowStore } from '@Stores/requestFlow.store';
import { useRequestSessionStore } from '@Stores/requestSession.store';
import { isQrScanArrival } from '@Stores/requestSessionStore.utils';
import { getDashboardContextApi } from '@Api/navigation.api';

const requestSessionStore = useRequestSessionStore();

provide('backToDashboard:hostRouter', getHostRouter());
provide('backToDashboard:slug', () => getCompanySlug());
provide('backToDashboard:flowStore', useRequestFlowStore());
// Cache the context promise so the task views that now read it don't each refetch
// GET /Navigation/GetDashboardContext; clear on failure so a transient error retries.
let dashboardContextPromise: ReturnType<typeof getDashboardContextApi> | null = null;
provide('backToDashboard:getDashboardContext', () => {
    const { qrSessionToken } = requestSessionStore;
    if (qrSessionToken && isQrScanArrival(qrSessionToken)) {
        return Promise.resolve({ participantPortalEnabled: false, dealId: null });
    }
    if (!dashboardContextPromise) {
        dashboardContextPromise = getDashboardContextApi().catch((error) => {
            dashboardContextPromise = null;
            throw error;
        });
    }
    return dashboardContextPromise;
});

onBeforeMount(async () => {
    console.log('[Request MFE] mounted');
});
</script>
<template>
    <div class="mfe-container">
        <router-view  />
    </div>
</template>



<style lang="scss" scoped>

.mfe-container {
    height: 100%;

    & > * {
        height: 100%;
    }
}

</style>

